class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    
    this.summaryToggle.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();
      const now = Date.now();
      if (this._lastToggle && now - this._lastToggle < 800) return;
      this._lastToggle = now;
      this._isOpen ? this.close() : this.open(event);
    });

    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));
    this.summaryToggle.setAttribute('role', 'button');

    this.detailsContainer.addEventListener('toggle', () => {
      if (this._isOpen && !this.detailsContainer.hasAttribute('open')) {
    this.detailsContainer.setAttribute('open', true);
      }
  });

    this._isOpen = false;
  }

  isOpen() {
    return this._isOpen;
  }

  onBodyClick(event) {
    if (event.target.classList.contains('modal-overlay')) {
      this.close(false);
    }
  }

open(event) {
  event.target.closest('details').setAttribute('open', true);
  this._isOpen = true;
  this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
  document.body.classList.add('overflow-hidden');
  setTimeout(() => {
    document.body.addEventListener('click', this.onBodyClickEvent);
  }, 2000);
  trapFocus(
    this.detailsContainer.querySelector('[tabindex="-1"]'),
    this.detailsContainer.querySelector('input:not([type="hidden"])')
  );
  setTimeout(() => {
    const input = this.detailsContainer.querySelector('input:not([type="hidden"])');
    if (input) {
      input.scrollIntoView({ block: 'start', behavior: 'smooth' });
    }
  }, 400);
  const modal = this.detailsContainer.querySelector('.search-modal');
    if (modal && window.innerWidth < 750) {
      document.body.appendChild(modal);
      this._movedModal = modal;
      modal.style.position = 'fixed';
      modal.style.top = '0';
      modal.style.left = '0';
      modal.style.right = '0';
      modal.style.bottom = '0';
      modal.style.zIndex = '9999';
      modal.style.height = '100dvh';
    }
}

  close(focusToggle = true) {
    this._isOpen = false;
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
 if (this._movedModal) {
    this.detailsContainer.appendChild(this._movedModal);
    this._movedModal.style.cssText = '';
    this._movedModal = null;
  }
}
}

customElements.define('details-modal', DetailsModal);
